import React from 'react';
import EmailVerificationPage from './EmailVerificationPage';

const EmailVerificationPageWrapper = () => {
  // No token detection needed - codes are entered manually
  return <EmailVerificationPage />;
};

export default EmailVerificationPageWrapper;